document.addEventListener("DOMContentLoaded", function() {
  const slides = document.querySelectorAll('.testimonial-slide');
  const indicators = document.querySelectorAll('.testimonial-indicator');
  let currentIndex = 0;
  const totalSlides = slides.length;

  // Function to change slide
  function changeSlide() {
    currentIndex = (currentIndex + 1) % totalSlides; // Loop back to the first slide after the last one
    updateSlider();
  }

  // Function to update the slider to the current slide
  function updateSlider() {
    const testimonialWrapper = document.querySelector('.testimonial-wrapper');
    testimonialWrapper.style.transform = `translateX(-${currentIndex * 100}%)`;

    // Update active indicator
    indicators.forEach((dot, index) => {
      dot.classList.remove('active');
      if (index === currentIndex) {
        dot.classList.add('active');
      }
    });
  }

  // Manual navigation using dots
  indicators.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      currentIndex = index;
      updateSlider();
    });
  });

  // Automatically change slides every 15 seconds
  setInterval(changeSlide, 15000);

  // Initialize the first slide and indicator
  updateSlider();
});
